<template>
  <router-link
    :to="{name: 'system_month_payer_group', params: {groupYearMonth: groupYearMonth}}"
  >
    {{groupYearMonth}}
  </router-link>
</template>

<script>
export default {
  name: 'MonthPayerGroupLink',

  props: {
    groupYearMonth: {
      type: String,
      required: true
    }
  }
};
</script>
